import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IdentificationType } from '../models/identification-type.model';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdentificationTypeService {
  constructor(private httpClient: HttpClient) {}

  getIdentificationTypes() : Observable<IdentificationType[]> {
    return this.httpClient.get<IdentificationType[]>('assets/components/identification-types/identification-types.json').pipe(
      map(data => data)
    );
  }
}
